// src/store/Program/programReducer.js
 import * as actionTypes from "../ActionTypes/index.js"
  
  const initialState = {
    loading: false,
    programs: [],
    error: null,
  };
  
  export default function programReducer(state = initialState, action) {
    switch (action.type) {
      case actionTypes.SAVE_PROGRAM_REQUEST:
        return { ...state, loading: true, error: null };
  
      case actionTypes.SAVE_PROGRAM_SUCCESS:
        return {
          ...state,
          loading: false,
          programs: [...state.programs, action.data], // append saved program
        };
  
      case actionTypes.SAVE_PROGRAM_FAILURE:
        return { ...state, loading: false, error: action.error };
        case actionTypes.UPDATE_PROGRAM_REQUEST:
            return { ...state, updating: true, error: null };
          case actionTypes.UPDATE_PROGRAM_SUCCESS:
            return { ...state, updating: false, programData: action.data };
          case actionTypes.UPDATE_PROGRAM_FAILURE:
            return { ...state, updating: false, error: action.error };
            case actionTypes.DELETE_PROGRAM_REQUEST:
                return { ...state, deleting: true, error: null };
          
                case actionTypes.DELETE_PROGRAM_SUCCESS:
                  return {
                    ...state,
                    deleting: false,
                    programs: state.programs.filter(
                      (p) => p.programObjId !== action.payload.programObjId
                    ),
                  };
                
                  case actionTypes.DELETE_PROGRAM_FAILURE:
                    return {
                      ...state,
                      deleting: false,
                      error: action.payload, // payload could be { type, programObjId, error }
                    };
                  
      default:
        return state;
    }
  }
  